import { cn } from "@/lib/utils";

/**
 * Google Maps gesture mode used across the app: the wheel scrolls the page
 * unless the platform zoom modifier is held.
 */
export const MAP_ZOOM_GESTURE_HANDLING = "cooperative" as const;

function zoomModifierLabel(): string {
  if (typeof navigator === "undefined") return "Ctrl";
  const platform =
    (navigator as Navigator & { userAgentData?: { platform?: string } })
      .userAgentData?.platform ||
    navigator.platform ||
    navigator.userAgent;
  return /mac|iphone|ipad|ipod/i.test(platform) ? "⌘ Command" : "Ctrl";
}

function zoomHintText(): string {
  return `Hold ${zoomModifierLabel()} + scroll to zoom`;
}

/**
 * Overlay telling the user that zooming needs the platform modifier key.
 * Render inside a `relative` container that wraps the map. It sits top-centre
 * to clear the map type, fullscreen, and Google attribution controls.
 */
export function MapZoomHint({ className }: { className?: string }) {
  return (
    <div
      role="note"
      data-slot="map-zoom-hint"
      className={cn(
        "pointer-events-none absolute top-2 left-1/2 z-10 -translate-x-1/2 rounded-md bg-background/85 px-2 py-1 text-xs whitespace-nowrap text-muted-foreground shadow-sm ring-1 ring-border",
        className,
      )}
    >
      {zoomHintText()}
    </div>
  );
}
